import request from '../utils/request';

export interface INewsProps {
  limit: number;
  page: number;
  type?: 1 | 2 | 3 | null;
}

export function listNews(params: INewsProps) {
  return request.get('/api/news_activities/get_newsActivities', {
    params,
  });
}

export function getNews(id: number) {
  return request.get('/api/news_activities/detail', {
    params: { id },
  });
}
